import { FileWarning, Gauge, Link2Off, Smartphone } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { GlowField } from "@/components/site/GlowField";
import { SectionIntro } from "@/components/site/Bits";
import { WebsiteCheckForm } from "@/components/forms/WebsiteCheckForm";

const CHECKS = [
  [Smartphone, "How it looks and works on phones"],
  [Gauge, "Slow-loading pages"],
  [FileWarning, "Missing contact info, hours, or calls to action"],
  [Link2Off, "Broken links and forms"],
];

export const WebsiteCheck = () => (
  <section id="website-check" className="section relative isolate overflow-hidden border-t border-white/[0.08]" data-testid="website-check-section">
    <GlowField className="glow-side opacity-70" />
    <div className="container-x grid items-start gap-12 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-6">
        <SectionIntro
          eyebrow="Free website check"
          title={["Find out what's broken", "on your current site."]}
          copy="Send us your link. One of the founders will look it over by hand and email you a free, plain-English review of what's broken and what to fix first."
          testId="website-check-heading"
        />
        <Reveal as="ul" delay={0.15} className="mt-8 space-y-3">
          {CHECKS.map(([Icon, label]) => (
            <li key={label} className="flex items-center gap-3 text-[15px] text-white/90">
              <span className="grid h-8 w-8 shrink-0 place-items-center rounded-md border border-white/10 bg-white/[0.03]">
                <Icon className="h-4 w-4 text-[#2DD4D4]" aria-hidden="true" />
              </span>
              {label}
            </li>
          ))}
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-6">
        <div className="rounded-2xl border border-white/10 bg-[#0E1015]/80 p-6 shadow-[0_40px_100px_-40px_rgba(37,99,235,0.45)] backdrop-blur-xl sm:p-8">
          <p className="text-lg font-medium tracking-tight">Get your free website check</p>
          <p className="mb-6 mt-1 text-sm text-[#A1A1AA]">Takes 30 seconds. We'll reply by email.</p>
          <WebsiteCheckForm />
        </div>
      </Reveal>
    </div>
  </section>
);
